import { PlusOutlined } from '@ant-design/icons';
import React from 'react';

import styles from './index.module.scss';

type AntdUploadChildrenProps = {
  text?: string;
};

export const AntdUploadChildren = ({ text }: AntdUploadChildrenProps) => {
  return (
    <div className={styles.uploadButton}>
      <PlusOutlined rev={undefined} />
      <p>{text || 'Upload'}</p>
    </div>
  );
};
